// extracted by mini-css-extract-plugin
module.exports = {"location":"userCardSmartTooltip_location__2Iyhg","locationTooltip":"userCardSmartTooltip_locationTooltip__1v-ME","emptyLocation":"userCardSmartTooltip_emptyLocation__3AxyA"};